<template>
  <div class="countdown-wrapper">
    <span class="font-bold text-6xl text-purple-gradient">{{ time }}</span>
  </div>
</template>

<script>
export default {
  name: 'Countdown',
  props: {
    time: Number,
  },
};
</script>

<style lang="scss" scoped>
.countdown-wrapper {
  @apply absolute flex justify-center items-center;
  top: 0;
  bottom: 0;
  transform: translateY(-25%);
  background: url('../../assets/FootScan/countdown-circle.svg') no-repeat center;
  background-size: contain;
  width: 138px;
  height: 138px;
  margin: auto;
  box-sizing: border-box;
}
</style>
